import Link, { LinkProps } from './Link';

export default Link;
export type { LinkProps };
